var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalScreens(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 53,
    viewBox: "0 0 61 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6973 42.7003V0H0.303467V42.7003H23.423V48.0084C23.423 48.984 22.6292 49.7777 21.6536 49.7777H16.3456V53.3164H44.6552V49.7777H39.3471C38.3715 49.7777 37.5778 48.984 37.5778 48.0084V42.7003H60.6973ZM3.84217 3.5387H57.1586V39.1616H3.84217V3.5387ZM34.3434 49.7777H26.6573C26.8537 49.2239 26.9617 48.6287 26.9617 48.0084V42.7003H34.0391V48.0084C34.0391 48.6287 34.147 49.2239 34.3434 49.7777Z",
    fill: "#474545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49829 7.07812H53.5014V10.6168H7.49829V7.07812Z",
    fill: "#474545"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49829 14.1523H11.037V17.691H7.49829V14.1523Z",
    fill: "#474545"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5759 14.1523H18.1146V17.691H14.5759V14.1523Z",
    fill: "#474545"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6536 14.1523H25.1923V17.691H21.6536V14.1523Z",
    fill: "#474545"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7312 14.1523H32.2699V17.691H28.7312V14.1523Z",
    fill: "#474545"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8091 14.1523H39.3478V17.691H35.8091V14.1523Z",
    fill: "#474545"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8857 14.1523H46.4244V17.691H42.8857V14.1523Z",
    fill: "#474545"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9634 14.1523H53.5021V17.691H49.9634V14.1523Z",
    fill: "#474545"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49829 21.2305H11.037V24.7692H7.49829V21.2305Z",
    fill: "#474545"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5759 21.2305H18.1146V24.7692H14.5759V21.2305Z",
    fill: "#474545"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6536 21.2305H25.1923V24.7692H21.6536V21.2305Z",
    fill: "#474545"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7312 21.2305H32.2699V24.7692H28.7312V21.2305Z",
    fill: "#474545"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8091 21.2305H39.3478V24.7692H35.8091V21.2305Z",
    fill: "#474545"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8857 21.2305H46.4244V24.7692H42.8857V21.2305Z",
    fill: "#474545"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9634 21.2305H53.5021V24.7692H49.9634V21.2305Z",
    fill: "#474545"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49829 28.3125H11.037V31.8512H7.49829V28.3125Z",
    fill: "#474545"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5759 28.3125H18.1146V31.8512H14.5759V28.3125Z",
    fill: "#474545"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6536 28.3125H25.1923V31.8512H21.6536V28.3125Z",
    fill: "#474545"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7312 28.3125H32.2699V31.8512H28.7312V28.3125Z",
    fill: "#474545"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8091 28.3125H39.3478V31.8512H35.8091V28.3125Z",
    fill: "#474545"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalScreens);
export default __webpack_public_path__ + "static/media/totalScreens.e0cd8f8c853c56a60ff2967ddfa7d8f3.svg";
export { ForwardRef as ReactComponent };